import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { useIsMatchComponent } from '../../hooks';

import styles from './MatchPeriodLabel.module.scss';

type MatchPeriodLabelProps = PropsWithChildren<{
  className?: string;
  title?: string;
}>;

export const MatchPeriodLabel: FC<MatchPeriodLabelProps> = ({
  title,
  children,
  className,
}) => {
  const isMatchComponent = useIsMatchComponent();
  const periodClassNames = classNames(styles.periodLabel, {
    [styles.matchPeriodLabel]: isMatchComponent,
  }, className);

  return (
    <span title={title}
          className={periodClassNames}>
      {children}
    </span>
  );
};
